import { MQ } from '../tools/MQ.js';

export function show($loader, disableScroll = true) {
	$loader.removeClass('loader--hidden');
	if (disableScroll && MQ('mdDown')) disableScrolling();
}

export function hide($loader) {
	$loader.addClass('loader--hidden');
	enableScrolling();
}

function disableScrolling() {
	$('html').addClass('loader__scrolling--disable');
}

function enableScrolling() {
	$('html').removeClass('loader__scrolling--disable');
}
